import RcDomainObject from "./RcDomainObject";

export default class RcParams extends RcDomainObject {

  static MODEL_NAME = "RcParams";

  static Fields = {
    FILTER: "filter",
  }

  constructor(domain, modelName = RcParams.MODEL_NAME) {
    super(domain, {}, modelName);
  }

  withFilter(filter) {
    this.put(RcParams.Fields.FILTER, filter);
    return this;
  }
}
  